import React from 'react';
import { Calendar, Printer, ArrowLeft, Edit, BookOpen, GraduationCap, FileText } from 'lucide-react';

/**
 * Composant d'en-tête pour la page détail d'examen
 */
const PageHeader = ({ examen, id, navigate, handlePrint }) => (
  <div className="bg-gradient-to-r from-[#202654] to-[#2a2f6c] p-6 flex justify-between items-center print:hidden mt-6 mx-4 rounded-lg">
    <div className="flex items-center space-x-4">
      <button
        onClick={() => navigate('/examens')}
        className="text-white hover:bg-white/10 p-2 rounded-full transition-colors"
        aria-label="Retour à la liste"
      >
        <ArrowLeft className="h-6 w-6" />
      </button>
      <div>
        <h1 className="text-2xl font-bold text-white mb-2">{examen.libelle}</h1>
        <div className="flex items-center space-x-4 text-sm">
          <div className="flex items-center space-x-2">
            <GraduationCap className="h-4 w-4 text-white/80" />
            <span className="text-white/90">Classe:</span>
            <span className="px-2 py-1 bg-white/20 text-white rounded-md font-medium">
              {examen.classe?.libelle || 'Non définie'}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <BookOpen className="h-4 w-4 text-white/80" />
            <span className="text-white/90">Type:</span>
            <span className="px-2 py-1 bg-white/20 text-white rounded-md font-medium">
              {examen.type_examen || 'Non défini'}
            </span>
          </div>
        </div>
        {examen.description && (
          <div className="mt-2 flex items-start space-x-2">
            <FileText className="h-4 w-4 text-white/80 mt-0.5 flex-shrink-0" />
            <p className="text-sm text-white/80 line-clamp-2">{examen.description}</p>
          </div>
        )}
      </div>
    </div>
    <div className="flex items-center space-x-3">
      <div className="hidden md:flex items-center space-x-2 bg-white/10 px-3 py-1.5 rounded-lg">
        <Calendar className="h-4 w-4 text-white/80" />
        <span className="text-sm text-white/90">{examen.annee?.libelle || 'Année académique'}</span>
      </div>
      <button
        onClick={() => navigate(`/examens/${id}/edit`)}
        className="inline-flex items-center px-4 py-2 bg-white/10 text-white font-medium rounded-md hover:bg-white/20 transition-colors"
        aria-label="Modifier l'examen"
      >
        <Edit className="h-5 w-5 mr-2" />
        Modifier
      </button>
      <button
        onClick={handlePrint}
        className="inline-flex items-center px-4 py-2 bg-white text-[#202654] font-medium rounded-md hover:bg-white/90 transition-colors shadow-sm"
        aria-label="Imprimer l'examen"
      >
        <Printer className="h-5 w-5 mr-2" />
        Imprimer
      </button>
    </div>
  </div>
);

export default PageHeader; 